export enum BreakpointsEnum {
    MOBILE_WIDTH_IN_PX = 576,
    TABLET_WIDTH_IN_PX = 768,
    LAPTOP_WIDTH_IN_PX = 992,
    DESKTOP_WIDTH_IN_PX = 1200,
    LARGE_DESKTOP_WIDTH_IN_PX = 1440,
}
